import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { videoFolderSelectors } from '../../../../store/modules/videoFolder';

import { NavigationContext } from './../../../Navigation/NavigationContext';

export default () => {
  const { setParams } = useContext(NavigationContext);
  const folderId = useSelector(videoFolderSelectors.selectCurrentFolderId);

  useEffect(() => {
    folderId && setParams({ folderId });
  }, [folderId]);
};
